import muiIcons from "../../../components/icons/mui-icons";

export const userCardData = [
  {
    name: "David Hopkins",
    email: "uilib@gmail.com",
    position: "UI/UX Designer",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    name: "James Mitchell",
    email: "uilib@gmail.com",
    position: "Front-end Developer",
    photoUrl: "/assets/images/faces/3.jpg",
  },
];

export const authorListData = [
  {
    name: "David Hopkins",
    email: "uilib@gmail.com",
    profit: 500,
    position: "UI/UX Designer",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    name: "James Mitchell",
    email: "uilib@gmail.com",
    profit: 400,
    position: "Front-end Developer",
    photoUrl: "/assets/images/faces/3.jpg",
  },
  {
    name: "Jessica Mitchell",
    email: "uilib@gmail.com",
    profit: 800,
    position: "Back-end Developer",
    photoUrl: "/assets/images/faces/4.jpg",
  },
  {
    name: "Smith Doe",
    email: "Smith@gmail.com",
    profit: 200,
    position: "Content Writer",
    photoUrl: "/assets/images/faces/1.jpg",
  },
  {
    name: "Jhon Doe",
    email: "Jhon@gmail.com",
    profit: 700,
    position: "Production Manager",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    name: "Alex",
    email: "Otttio@gmail.com",
    profit: 900,
    position: "Full Stack Developer",
    photoUrl: "/assets/images/faces/3.jpg",
  },
  {
    name: "Mitchell",
    email: "uilib@gmail.com",
    profit: 600,
    position: "Back-end Developer",
    photoUrl: "/assets/images/faces/4.jpg",
  },
];

export const developerListData = [
  {
    name: "David Hopkins",
    email: "uilib@gmail.com",
    position: "UI/UX Designer",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    name: "James Mitchell",
    email: "uilib@gmail.com",
    position: "Front-end Developer",
    photoUrl: "/assets/images/faces/3.jpg",
  },
  {
    name: "Jessica Mitchell",
    email: "uilib@gmail.com",
    position: "Back-end Developer",
    photoUrl: "/assets/images/faces/4.jpg",
  },
];

export const productCardData = [
  {
    price: 40,
    name: "Product Featured",
    store: "By Nike Store",
    photoUrl: "/assets/images/products/shows.png",
    Icon: muiIcons.CartIcon,
    details:
      "Create Usable interface and designs @uilib.com visit our page For more details",
  },
  {
    price: 40,
    name: "Product Featured",
    store: "By Nike Store",
    photoUrl: "/assets/images/products/camera.png",
    Icon: muiIcons.CartIcon,
    details:
      "Create Usable interface and designs @uilib.com visit our page For more details",
  },
];
